const ALL_SELECT_OPTION_ITEM = { label: 'All', value: 'ALL' }

export default ALL_SELECT_OPTION_ITEM
